import { render, staticRenderFns } from "./ShippingLabelModal.vue?vue&type=template&id=204a8fda&scoped=true"
import script from "./ShippingLabelModal.vue?vue&type=script&lang=js"
export * from "./ShippingLabelModal.vue?vue&type=script&lang=js"
import style0 from "./ShippingLabelModal.vue?vue&type=style&index=0&id=204a8fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204a8fda",
  null
  
)

export default component.exports